import React, { useState, useEffect } from 'react';
import { useModal } from 'src/state/modal';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { storage } from '@uhg-abyss/web/tools/storage';
import { event } from '@uhg-abyss/web/tools/event';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';

export const NavMenuExitLinkModal = () => {
  const { modals, modalData } = useModal.state();
  const { toggleModal } = useModal.actions();
  const [checkboxSelected, setCheckboxSelected] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    if (modalData?.NavMenuExitLink) {
      setData(modalData.NavMenuExitLink);
    }
  }, [modalData]);

  //TODO button content needs to have a default value
  const { modalContent, buttonContent = '', to, storageKey } = data;

  const handleClose = () => {
    toggleModal({
      key: 'NavMenuExitLink',
      isOpen: false,
    });
  };

  const handleClick = () => {
    if (checkboxSelected) {
      storage.local.set(storageKey, true);
    }
    event('EXIT_LINK_NAVIGATE', { linkText: buttonContent });
    handleClose();
  };

  return (
    <Modal
      isOpen={modals.NavMenuExitLink}
      onClose={handleClose}
      title={modalContent}
      titleAlign="center"
      footer={
        <Modal.Section
          css={{
            'abyss-modal-section-root': {
              padding: '8px',
            },
          }}
        >
          <Layout.Stack alignLayout="center">
            <Button
              id="close-button"
              aria-label="Click to navigate to external link"
              onClick={handleClick}
              href={to}
              openNewWindow
              after={
                <IconMaterial icon="launch" size="18px" color="$primary2" />
              }
              css={{
                'abyss-button-root': {
                  width: '100%',
                },
              }}
            >
              {buttonContent}
            </Button>
            <Button
              id="close-button"
              aria-label="Click to cancel navigating to an external link"
              onClick={handleClose}
              variant="outline"
            >
              Close
            </Button>
          </Layout.Stack>
        </Modal.Section>
      }
      css={{
        'abyss-modal-content-container': {
          width: '800px',
          top: '-80px',
        },
        'abyss-modal-content-title': {
          lineHeight: '32px !important',
          fontSize: '28px !important',
        },
        'abyss-modal-body': {
          borderTop: `1px solid $gray4`,
        },
      }}
    >
      <Modal.Section
        css={{
          'abyss-modal-section-root': {
            padding: '8px 24px',
          },
        }}
      >
        <Checkbox
          isChecked={checkboxSelected}
          onChange={() => setCheckboxSelected(!checkboxSelected)}
        >
          Don't show this message again.
        </Checkbox>
      </Modal.Section>
    </Modal>
  );
};
